var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.64,255.1V194.87H10.4V179.78H23.64V134.64H10.4V119.56H23.64V74.42H11.73V59.33H23.65V-.9H240v256ZM81.11,240H224.92V14.19H81.11Zm-42.38,0H66V14.19H38.73V59.33H52V74.42H38.73v45.14H52v15.08H38.73v45.14H52v15.09H38.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.65,172.57V166.4c0-10.08,3.72-19.87,10.76-28.3a58.72,58.72,0,0,1,20.84-15.66,35.07,35.07,0,0,1-10.19-37,34.33,34.33,0,0,1,32.72-24.2h.36a34.28,34.28,0,0,1,32.57,24.89,35,35,0,0,1-10.91,36.79A62,62,0,0,1,196,138.64c7.16,8.38,11,18,11,27.76v6.17Zm91.13-15.3C184.56,144.91,169.71,133,151.84,133c-13.78,0-31,9.67-36.41,24.31Zm-37-80.74A19.58,19.58,0,1,0,172,96.11,19.43,19.43,0,0,0,152.78,76.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.70d78d99.svg";
export { ForwardRef as ReactComponent };